import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/(frontend)/search/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/workspace/src/search/Component.tsx");
